import {
  AfterViewInit,
  Directive, inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ScrollDispatcher } from "@angular/cdk/overlay";
import { Subscription } from "rxjs";

import { LorenBaseFeature } from "../loren-base-feature/loren-base-feature";
import { LorenScrollService } from "../../services/loren-scroll-service/loren-scroll.service";
import {
  LorenBreakpointObserverService
} from "../../services/loren-breakpoint-observer-service/loren-breakpoint-observer.service";
import {
  LorenNavService
} from "../../modules/loren-nav/components/loren-nav/services/loren-nav-service/loren-nav.service";

/// this is an updated copy of the LorenBaseEntityCrudFeatureDirective. After
/// all the components that use the old directive have been reworked to use
/// this one instead, the two will be unified.
@Directive()
export abstract class LorenBaseEntityCrudFeatureWithErrorHandlingDirective<T>
  extends LorenBaseFeature
  implements OnInit, OnDestroy, AfterViewInit
{
  public entities: T[] = [];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public error: any = null;
  public lastSelectedEntity: T;
  public allData;
  protected readonly activatedRoute = inject(ActivatedRoute);
  protected readonly breakpointObserverService = inject(LorenBreakpointObserverService);
  protected readonly lorenNavService = inject(LorenNavService);
  protected readonly scrollDispatcher = inject(ScrollDispatcher);
  protected readonly scrollService = inject(LorenScrollService);

  @ViewChild("entityDetails") entityDetails;
  detailsMarginTop = 0;

  private scrollSubscription: Subscription;

  // eslint-disable-next-line @angular-eslint/prefer-inject
  protected constructor(private resolveName: string) {
    super();
  }

  ngOnInit(): void {
    this.allData = this.activatedRoute.snapshot.data[this.resolveName];
    this.entities = this.allData.entities;
    this.error = this.allData.error;
  }

  onEntitySelected(entity) {
    this.lastSelectedEntity = entity;
  }

  ngAfterViewInit(): void {
    if (!this.isHandset && this.scrollService && this.scrollDispatcher) {
      const content = this.scrollService.getScrollableContent();
      const nativeElement = content.nativeElement;
      this.scrollSubscription = this.scrollDispatcher
        .ancestorScrolled(content)
        .subscribe(() => {
          this.detailsMarginTop = nativeElement.scrollTop;
        });
    }
  }

  ngOnDestroy(): void {
    if (this.scrollSubscription) {
      this.scrollSubscription.unsubscribe();
    }
  }
}
